import { useQuery } from "@tanstack/react-query";

import { getErrorMessage } from "../utils/utilities";
import { getReportAuditTrail } from "../services/reportService";

export interface ProgressTrail {
	_id: string;
	createdAt: string;
	projectId: string;
	updatedAt: string;
	userDesignation: string;
	userId: string;
	userName: string;
	description: string;
}

const useAuditTrail = (projectId: string) => {
    const { data, dataUpdatedAt, error, isFetching, refetch } = useQuery<ProgressTrail[]>({
        queryKey: ['audit-trail', projectId],
        queryFn: () => getReportAuditTrail(projectId!),
        initialData: [],
    });

    return {
        progressTrail: data,
        loading: isFetching,
        error: error ? getErrorMessage(error) : '',
        lastUpdated: dataUpdatedAt,
        refetch,
    };
};
 
export default useAuditTrail;